"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Option = void 0;
const vue_strict_prop_1 = __importDefault(require("vue-strict-prop"));
const tsx = __importStar(require("vue-tsx-support"));
const Description_1 = require("@/components/Form/components/Description");
const constants = __importStar(require("@/components/Form/constants"));
const utils = __importStar(require("@/utils"));
const shared_1 = require("./shared");
exports.Option = tsx
    .componentFactoryOf()
    .create({
    name: constants.nameOption,
    props: {
        optionData: vue_strict_prop_1.default.ofType().required,
        name: shared_1.commonProps.name,
        variant: shared_1.commonProps.variant,
        fieldsetDisabled: shared_1.commonProps.disabled,
        fieldsetReadonly: shared_1.commonProps.readonly,
        labelClass: shared_1.commonProps.optionLabelClass,
        checked: (0, vue_strict_prop_1.default)(Boolean).default(false),
    },
    data() {
        return {
            descriptionId: `${constants.nameOption}-${this.name ?? ''}-desc-${utils.getUniqueId()}`,
        };
    },
    computed: {
        labelElementClass() {
            const isDisabled = this.fieldsetDisabled || this.optionData.disabled === true;
            const variantClasses = {
                default: [
                    'p-1 rounded-sm',
                    this.ifNonInteractiveStyle({
                        interactive: 'hover:bg-actionable-5 dark:hover:bg-actionable-60',
                    }),
                ],
                'card-like': [
                    'px-3! py-2 min-h-6',
                    'focus-within:outline-2 -outline-offset-2',
                    'outline-actionable-40',
                    this.ifNonInteractiveStyle({
                        interactive: this.ifCheckedStyle({
                            checked: [
                                'bg-actionable-5 dark:bg-actionable-60',
                                'hover:bg-actionable-10 dark:hover:bg-actionable-50',
                            ],
                            unchecked: 'hover:bg-actionable-2 dark:hover:bg-actionable-65',
                        }),
                        notInteractive: 'bg-neutral-1 dark:bg-neutral-60',
                    }),
                ],
                quiz: [
                    'px-3 py-2 rounded-sm',
                    this.ifNonInteractiveStyle({
                        interactive: [
                            'border-2',
                            this.ifCheckedStyle({
                                checked: 'border-actionable-10 dark:border-actionable-40',
                                unchecked: 'border-transparent hover:border-actionable-5 dark:hover:border-actionable-50',
                            }),
                        ],
                    }),
                    '[&_input]:self-start [&_input]:mt-1.25',
                ],
            }[this.variant];
            return [
                constants.nameOption,
                'grid gap-x-2 gap-y-0.5 items-center',
                'transition-colors duration-100',
                'm-0',
                this.ifNonInteractiveStyle({
                    interactive: [
                        'cursor-pointer',
                        this.ifCheckedStyle({
                            checked: 'text-actionable-70 dark:text-actionable-5',
                            unchecked: 'text-neutral-80 dark:text-white',
                        }),
                    ],
                    notInteractive: [
                        {
                            'cursor-not-allowed': isDisabled,
                        },
                        'text-neutral-50 dark:text-neutral-20',
                    ],
                }),
                variantClasses,
            ];
        },
    },
    methods: {
        ifCheckedStyle(o) {
            if (this.checked) {
                return o.checked;
            }
            return o.unchecked;
        },
        ifNonInteractiveStyle(o) {
            if (this.fieldsetDisabled ||
                this.fieldsetReadonly ||
                this.optionData.disabled === true) {
                return o.notInteractive;
            }
            return o.interactive;
        },
    },
    render() {
        const hasDescription = this.optionData.description != null;
        return (<label class={this.labelElementClass} data-cy={constants.nameOption} data-checked={this.checked} data-disabled={this.optionData.disabled === true}>
                    {utils.renderScopedSlot({ descriptionId: this.descriptionId }, this.$scopedSlots.inputs, () => utils.emptyVNode())}
                    <span data-cy="option-label" class={[this.labelClass]}>
                        {this.optionData.label}
                    </span>
                    {utils.ifOrEmpty(hasDescription, () => (<Description_1.Description class={{
                    'text-neutral-50 dark:text-neutral-20': this.optionData.disabled === true,
                    'col-start-2': this.variant === 'quiz',
                }} id={this.descriptionId}>
                            {this.optionData.description}
                        </Description_1.Description>))}
                </label>);
    },
});
